<div class="modal-backdrop" (click)="onBackdropClick($event)">
  <div #dialog class="modal-container" role="dialog" aria-modal="true" [attr.aria-label]="modalTitle()" tabindex="-1">
    <div class="modal-header">
      <h1 class="modal-title" data-testid="modal-title">{{ modalTitle() }}</h1>
      <button data-testid="modal-close-btn" type="button" class="close-button" [disabled]="busy()"
        (click)="onCloseClick()" [attr.aria-label]="'general.close' | translate">
        <img src="assets/icons/close.svg" alt="" aria-hidden="true" class="close-icon" />
      </button>
    </div>

    <div class="modal-body" data-testid="modal-body">
      <div class="content-wrapper">
        <div class="scrollable-content">
          <ng-content select="[slot='modal-content']"></ng-content>
        </div>
      </div>

      <div #footerContent class="modal-footer" [class.has-footer]="hasFooter()">
        <ng-content select="[slot='modal-footer']"></ng-content>
      </div>
    </div>
  </div>
</div>
